import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import cx from 'classnames';
import { Dropdown, Menu } from '@storable/canaveral-components';
import LocalePill from '../LocalePill';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  componentClass: PropTypes.element.isRequired,
  locale: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  locales: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
  })).isRequired,
};

const defaultProps = {
  className: undefined,
};

const LocalesDropdown = ({
  className,
  componentClass: MenuItem,
  locale,
  locales,
  ...rest
}) => {
  const classes = cx(
    styles.dropdown,
    className,
  );

  return (
    <Dropdown
      className={classes}
      toggle={(
        <Dropdown.Toggle>
          <LocalePill locale={locale} />
        </Dropdown.Toggle>
      )}
    >
      <Menu header={<Menu.Header title="Locales" />}>
        {locales.map(otherLocale => (
          <MenuItem
            key={otherLocale.code}
            locale={otherLocale}
            {...rest}
          />
        ))}
      </Menu>
    </Dropdown>
  );
};

LocalesDropdown.propTypes = propTypes;
LocalesDropdown.defaultProps = defaultProps;

LocalesDropdown.fragments = {
  locale: gql`
    fragment LocalesDropdownLocale on Locale {
      code
      ...LocalePillLocale
    }

    ${LocalePill.fragments.locale}
  `,
};

export default LocalesDropdown;
